import { render } from "./cart-freebie-card.vue?vue&type=template&id=63668392"
import script from "./cart-freebie-card.vue?vue&type=script&lang=js"
export * from "./cart-freebie-card.vue?vue&type=script&lang=js"

import "./cart-freebie-card.vue?vue&type=style&index=0&id=63668392&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__